import { parseArtikelEtikettScan } from "@/lib/artikelEtikett";
import {
  getHeroArticleById,
  heroArticleOrderText,
  searchHeroArticles,
  type HeroArticleSuggestion,
} from "@/lib/material";
import { resolveMaterialUnit } from "@/lib/materialUnits";
import { ApiError } from "@/lib/apiClient";

export interface ScannedMaArtikel {
  article: HeroArticleSuggestion;
  text: string;
  einheit: string;
}

export async function resolveArtikelFromEtikettScan(raw: string): Promise<ScannedMaArtikel> {
  const parsed = parseArtikelEtikettScan(raw);
  if (!parsed) {
    throw new Error("Kein Artikel-QR erkannt. Bitte das Etikett erneut vor die Kamera halten.");
  }

  let article: HeroArticleSuggestion;
  try {
    article =
      parsed.kind === "artikelId"
        ? await getHeroArticleById(parsed.id)
        : await resolveArtikelFromEan(parsed.ean);
  } catch (err) {
    if (err instanceof ApiError && err.status === 404) {
      throw new Error("Artikel nicht gefunden. Ist das Etikett noch aktuell?");
    }
    throw err instanceof Error ? err : new Error("Artikel konnte nicht geladen werden.");
  }

  if (!article.artikel_id) {
    throw new Error("Artikel nicht gefunden. Ist das Etikett noch aktuell?");
  }

  return {
    article,
    text: heroArticleOrderText(article),
    einheit: resolveMaterialUnit(article.einheit || article.hero_unit),
  };
}

async function resolveArtikelFromEan(ean: string): Promise<HeroArticleSuggestion> {
  const list = await searchHeroArticles(ean, { limit: 8 });
  const exact = list.find((item) => (item.ean || "").replace(/\D/g, "") === ean);
  const match = exact || (list.length === 1 ? list[0] : null);
  if (!match?.artikel_id) {
    throw new Error("Zur EAN wurde kein Artikel gefunden.");
  }
  return match;
}
